
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vxSearchResults: 'search/getSearchResults',
      vxStoryContent: 'search/getStoryContent',
      vxSelectedSortingOption: 'search/getSelectedSortingOption',
    }),
    selectedSortingOption: {
      get() {
        return this.vxSelectedSortingOption
      },
      set(value) {
        this.vxSetIsShowingFilters(false)
        this.vxSetSearchParameters({ sort: value })
        this.vxQuerySearchspring()
        this.$emit('setSortby', value)
      },
    },
  },
  mounted() {
    this.$emit('setSortby', this.vxSelectedSortingOption)
  },
  methods: {
    ...mapMutations({
      vxSetSearchParameters: 'search/setSearchParameters',
      vxSetIsShowingFilters: 'search/setIsShowingFilters',
    }),
    ...mapActions({
      vxQuerySearchspring: 'search/querySearchspring',
    }),
  },
}
